<template>
  <ValidationObserver ref="observer" class="w-100" tag="form">
    <div class="col-12">
      <SectionTitle :content="title" :has-line="true" />
      <div
        v-if="field.showQuestionnaireForStudent"
        class="col-12 mt-4 mb-4 mx-3"
      >
        <validation-provider
          v-if="hasValidationPending"
          key="textarea-questionnaire-status"
          v-slot="{ errors }"
          :rules="{ required: field.questionnaireStatus == 'Pendiente' }"
        >
          <CustomTextArea
            v-show="false"
            id="txtEmptyString"
            v-model="emptyString"
          />
          <error
            v-if="errors.length > 0"
            message="Favor de completar el Cuestionario de Intervención."
          />
        </validation-provider>
        <CustomStatusLink
          v-if="canShowInterventionQuestionnaire"
          :title="'Cuestionario de Intervención'"
          :status="field.questionnaireStatus"
          :params="statusLinkParams"
          :use-link-name="true"
          :link-to="'peiEvaluationServiceIntervention'"
        />
      </div>

      <div class="row mx-3 mt-1">
        <div class="col-md-4 col-sm-12 mt-2">
          <ValidationProvider
            key="eligibility-determination-date"
            v-slot="{ errors }"
            :rules="field.datePickerDate.required ? 'required' : ''"
          >
            <CustomDatePicker
              id="txtDatePicker"
              v-model="field.datePickerDate.model"
              :error="errors[0]"
              :custom-error-msg="field.datePickerDate.errorMsg"
              :max-date="field.datePickerDate.maxDate"
              :min-date="field.datePickerDate.minDate"
              :label="field.datePickerDate.label"
              :placeholder="field.datePickerDate.placeHolder"
              :disabled="field.datePickerDate.disabled"
              class="w-100"
            />
          </ValidationProvider>
        </div>
        <div class="col-md-4 col-sm-12 mt-3">
          <strong style="color: gray">
            {{ field.radioElegibility.label }}
          </strong>
          <ValidationProvider
            key="radio-elegibility-determination"
            v-slot="{ errors }"
            :rules="field.radioElegibility.required ? 'required' : ''"
          >
            <div class="input-group mt-2 align-group">
              <CustomRadio
                :error="errors[0]"
                :custom-error-msg="field.radioElegibility.errorMsg"
                :value="field.radioElegibility.model"
                :name="field.radioElegibility.label"
                :options="field.radioElegibility.options"
                is-inline
                :is-disabled="disabled"
                @input="radioElegibilityChange($event)"
              />
            </div>
          </ValidationProvider>
        </div>
        <div v-if="field.dropDownImpediment.visible" class="col-md-4 col-sm-12">
          <ValidationProvider
            key="eligibility-impediment-dd"
            v-slot="{ errors }"
            mode="eager"
            :rules="`${field.dropDownImpediment.required ? 'required' : ''}`"
          >
            <CustomDropDown
              :id="field.dropDownImpediment.name"
              v-model="field.dropDownImpediment.model"
              class="w-50 d-inline"
              :disabled="field.dropDownImpediment.disabled || disabled"
              :label="field.dropDownImpediment.label"
              :custom-error-msg="field.dropDownImpediment.errorMsg"
              :error="errors[0]"
              :placeholder="field.dropDownImpediment.placeHolder"
              :fieldkey="field.dropDownImpediment.fieldkey"
              :fieldname="field.dropDownImpediment.fieldname"
              :options="field.dropDownImpediment.items"
            />
          </ValidationProvider>
        </div>
      </div>

      <div v-if="field.radioElegibility.model === false" class="row">
        <div class="col-lg-6 col-md-9 col-sm-12 pl-4 ml-4 ">
          <error
            style="position:relative;right: 2px;"
            is-alert-mode
            message="Al seleccionar que el estudiante No es Elegible el mismo será Egresado."
          />
        </div>
      </div>

      <div class="row mx-3">
        <div
          class="col-12 mt-3"
          v-if="
            this.field.radioElegibility.model != null &&
              !this.field.radioElegibility.model
          "
        >
          <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            name="dissabilityOption"
          >
            <div>
              <CustomRadio
                v-model="field.dissabilityOption"
                :error="errors[0]"
                class="dissability-options"
                custom-error-msg="Favor seleccionar una razón de determinación"
                name="dissabilityOption"
                :options="field.radioDissabilities.options"
                :is-disabled="disabled"
              />
            </div>
          </ValidationProvider>
        </div>
        <div class="col-12">
          <ValidationProvider
            key="comment-eligibility-txtarea"
            v-slot="{ errors }"
            mode="eager"
            :rules="`${field.textAreaComment.required ? 'required' : ''}`"
          >
            <CustomTextArea
              id="txtAreaComment"
              class="mt-4"
              v-model="field.textAreaComment.model"
              :disabled="field.textAreaComment.disabled || disabled"
              :label="field.textAreaComment.label"
              :maxlength="field.textAreaComment.maxlength"
              :rows="field.textAreaComment.rows"
              :placeholder="field.textAreaComment.placeHolder"
              :error="errors[0]"
              :custom-error-msg="field.textAreaComment.errorMsg"
            />
          </ValidationProvider>
        </div>
      </div>

      <ImpedimentsManager
        v-if="canShowDeterminationQuestions"
        class="m-4"
        ref="ImpedimentsManager"
        v-model="impedimentsModel"
        :options="impedimentsOptions"
        :all-impediments="field.dropDownImpediment.items"
        :selected-impediment-ids="selectedImpedimentIds"
        :severity-options="field.dropDownSeverity.items"
        :disorders-options="field.dropDownDisordersMultiple.items"
        :is-disabled="disabled"
        @add-impediment="btnAddClick"
        @delete-impediment="removeAddImpedimentMultipleItemSelected"
      />

      <div class="row ml-4 pl-1 mt-3">
        <div class="mt-2">
          <strong class="d-inline-flex">
            {{ field.dropDownNumberMeetingsSelectEligibility.label }}
          </strong>
          <div class="ml-2 d-inline-flex">
            <ValidationProvider
              key="meetings-select-eligibility-dd"
              v-slot="{ errors }"
              mode="eager"
              rules="required"
            >
              <CustomDropDown
                :id="field.dropDownNumberMeetingsSelectEligibility.name"
                v-model="field.dropDownNumberMeetingsSelectEligibility.model"
                :class="isMobile ? 'w-100 mw-150' : 'w-50 mw-150'"
                :custom-error-msg="
                  field.dropDownNumberMeetingsSelectEligibility.errorMsg
                "
                :error="errors[0]"
                :placeholder="
                  field.dropDownNumberMeetingsSelectEligibility.placeHolder
                "
                :fieldkey="
                  field.dropDownNumberMeetingsSelectEligibility.fieldkey
                "
                :fieldname="
                  field.dropDownNumberMeetingsSelectEligibility.fieldname
                "
                :options="field.dropDownNumberMeetingsSelectEligibility.items"
                :disabled="disabled"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>

      <div class="row ml-4 pl-1 mt-2">
        <div class="mt-4">
          <strong class="d-inline">
            {{ field.radioHealthSpecialistNecessary.label }}
          </strong>
        </div>
        <div class="healt-specialist">
          <ValidationProvider
            key="health-specialist-necessary-radio"
            v-slot="{ errors }"
            :rules="
              `${
                field.radioHealthSpecialistNecessary.required ? 'required' : ''
              }`
            "
          >
            <div>
              <CustomRadio
                :error="errors[0]"
                :custom-error-msg="
                  field.radioHealthSpecialistNecessary.errorMsg
                "
                :value="field.radioHealthSpecialistNecessary.model"
                :name="field.radioHealthSpecialistNecessary.label"
                :options="field.radioHealthSpecialistNecessary.options"
                is-inline
                :is-disabled="disabled"
                @input="radioHealthSpecialistNecessaryChange($event)"
              />
            </div>
          </ValidationProvider>
        </div>
      </div>

      <div class="row ml-4 pl-1 mt-2" v-if="this.field.radioElegibility.model">
        <eligibility-determination-conditions
          v-model="this.modelConditions"
          :conditions="this.conditionsList"
          :disabled="disabled"
        />
      </div>

      <div
        v-if="field.radioParticipatedSpecialist.visible"
        class="row ml-4 pl-1 mt-2"
      >
        <div class="mt-4">
          <strong class="d-inline">
            {{ field.radioParticipatedSpecialist.label }}
          </strong>
        </div>
        <div class="ml-2 mt-4">
          <ValidationProvider
            key="participated-specialist-eligibility-radio"
            v-slot="{ errors }"
            :rules="
              `${field.radioParticipatedSpecialist.required ? 'required' : ''}`
            "
          >
            <div>
              <CustomRadio
                :error="errors[0]"
                :custom-error-msg="field.radioParticipatedSpecialist.errorMsg"
                :value="field.radioParticipatedSpecialist.model"
                :name="field.radioParticipatedSpecialist.label"
                :options="field.radioParticipatedSpecialist.options"
                is-inline
                :is-disabled="disabled"
                @input="radioParticipatedSpecialistChange($event)"
              />
            </div>
          </ValidationProvider>
        </div>
      </div>

      <div v-if="field.checkboxCertification.visible" class="pb-5">
        <validation-provider
          key="certification-eligibility-checkbox"
          v-slot="{ errors }"
          :rules="{ required: { allowFalse: false } }"
        >
          <div
            v-show="field.checkboxCertification.visible"
            class="row ml-4 pl-1 mt-4"
          >
            <div class="col-0 custom-control custom-checkbox">
              <input
                :id="field.checkboxCertification.name"
                v-model="field.checkboxCertification.model"
                :name="field.checkboxCertification.name"
                type="checkbox"
                class="custom-control-input"
                :disabled="disabled"
              />
              <label
                :for="field.checkboxCertification.name"
                class="custom-control-label font regular"
              >
                <span v-if="field.checkboxCertification.model != null">
                  <i class="ic-check" />
                </span>
              </label>
            </div>
            <div class="col-10">
              <span style="font-weight: 100">
                Certificamos que en caso de que el niño o joven haya sido
                considerado elegible para servicios de educación especial,
              </span>
              <strong>
                la decisión no se ha basado primordialmente en alguno de los
                siguientes factores: falta de instrucción en lectura o
                matemáticas o dominio limitado del idioma español.
              </strong>
            </div>
          </div>
          <div class="clearfix" />
          <div class="row ml-4 pl-1 mb-0">
            <Error
              v-if="
                (field.checkboxCertification.visible &&
                  field.checkboxCertification.model != true) ||
                  errors.length > 0
              "
              variant="no-border"
              message="Debe certificar la elegibilidad."
            />
          </div>
        </validation-provider>
      </div>
      <div v-if="tardinessInfo.isDeterminationLate" class="mt-5 mb-5">
        <SectionTitle
          content="Determinación de Elegibilidad fuera de Término"
          :has-line="true"
        />
        <div class="col-12">
          <p class="ml-3">
            Favor de seleccionar la razón para que la determinación de
            elegibilidad se haya realizado fuera de término. (0417)
          </p>
          <div class="col-8">
            <validation-provider
              key="tardiness-reason-eligibility"
              v-slot="{ errors }"
              :rules="{ required }"
            >
              <CustomDropDown
                v-model="tardinessModel.tardinessReason"
                :disabled="disabled"
                class="w-50 d-inline"
                :error="errors[0]"
                label="Razón:"
                placeholder="Seleccionar la razón"
                fieldkey="id"
                fieldname="name"
                :options="elegibilityTardinessReasons"
              />
            </validation-provider>
          </div>
          <div v-if="showTardinessComment">
            <div class="mt-3 mb-3 ml-3">
              <validation-provider
                key="tardiness-comment-eligibility"
                v-slot="{ errors }"
                :rules="{ required }"
              >
                <CustomTextArea
                  v-model="tardinessModel.tardinessComment"
                  :disabled="disabled"
                  label="Comentario:"
                  :maxlength="field.textAreaComment.maxlength"
                  :rows="field.textAreaComment.rows"
                  :placeholder="field.textAreaComment.placeHolder"
                  :error="errors[0]"
                />
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ValidationObserver>
</template>

<script>
import store from '@/store/index';
import loading from '@/mixin/loading.mixin';
import CustomStatusLink from '@/components/common/CustomStatusLink';
import QuestionnaireTypes from '@/utils/constants/questionnairetypes.js';
import validationMixin from '@/mixin/validation.mixin.js';
import alert from '@/mixin/alert.mixin';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { SectionTitle } from '@/components/pei/shared';
import {
  CustomDatePicker,
  ActionButton,
  CustomDropDown,
  CustomTextArea,
  CustomChipsGroup,
  CustomRadio,
} from '@/components/common';
import ImpedimentsEnum from '@/utils/constants/reg/impedimentsType';
import Error from 'custom-error';
import StudentStatuses from '@/utils/constants/student/studentStatuses';
import tardyRegistrationReasons from '@/utils/constants/pei/peiTardyRegistrationReasons.js';
import ImpedimentsManager from './impediments/ContainerManager';
import EligibilityDeterminationConditions from './EligibilityDeterminationConditions';
import studentTrianualService from '@/modules/student-trianual/api.js';
import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';

//JSF: TODO Agregar los estatuses de Cuestionario por ID y enviarlo desde el api para
//     tenerlo disponible para la comparacion si el CuestionarioStatusId es Completado
const QuestionnarieStatus = {
  Pendiente: 'Pendiente',
  Completado: 'Completado',
};

export default {
  mixins: [loading, alert, validationMixin],
  components: {
    ActionButton,
    CustomTextArea,
    ValidationObserver,
    CustomDropDown,
    CustomDatePicker,
    ValidationProvider,
    SectionTitle,
    CustomChipsGroup,
    CustomRadio,
    CustomStatusLink,
    Error,
    ImpedimentsManager,
    EligibilityDeterminationConditions,
  },
  data() {
    return {
      name: 'EligibilityDetermination',
      impedimentsOptions: [],
      impedimentsModel: {
        severity: null,
        isPartialHearing: null,
        disorders: null,
      },
      statusLinkParams: {
        from: 'Pos-Registro',
        questionnaireTypes: [QuestionnaireTypes.PrePruebaIntervencion],
        place: ['Inicio', 'Estudiante', 'Cuestionario de Intervención'],
        linkBack: '/student/registrygeneral',
      },
      emptyString: '',
      studentSie: store.getters['$_student/StudentSie'],
      ValidationTriggered: store.getters.getatValidationTriggered,
      title: 'Información de Determinación',
      showImpedimentMultipleSelected: false,
      //JA: This implementation is BRILLIANT!!!!! :/
      field: {
        showQuestionnaireForStudent: false,
        questionnaireStatus: '',
        datePickerDate: {
          required: true,
          disabled: this.disabled || (this.dateRegistration ? false : true),
          label: 'Fecha:',
          placeHolder: 'DD/MM/YYYY',
          maxDate: new Date(),
          minDate: this.dateRegistration,
          errorMsg: 'La fecha es requerida.',
          model: this.dateEligibility,
        },
        radioElegibility: {
          required: true,
          label: 'Elegible:',
          errorMsg: 'Marque si o no.',
          model: null,
          options: [
            { label: 'Si', value: true },
            { label: 'No', value: false },
          ],
        },
        dissabilityOption: null,
        textAreaComment: {
          label: 'Describa el resultado de la determinación de elegibilidad',
          required: true,
          disabled: false,
          isVisible: true,
          maxlength: 3000,
          rows: 5,
          placeHolder: 'Escribir comentario...',
          errorMsg: 'El comentario es requerido.',
          model: null,
        },
        dropDownNumberMeetingsSelectEligibility: {
          required: true,
          disabled: true,
          label:
            'Cantidad de reuniones que se llevaron a cabo para determinar elegibilidad:',
          name: 'dropDownNumberMeetingsSelectEligibility',
          placeHolder: 'Seleccione',
          fieldkey: 'id',
          fieldname: 'name',
          errorMsg: 'Favor seleccione la cantidad.',
          items: [
            { id: 1, name: '1' },
            { id: 2, name: '2' },
            { id: 3, name: '3' },
            { id: 4, name: '4' },
            { id: 5, name: '5' },
            { id: 6, name: '6' },
            { id: 7, name: '7' },
            { id: 8, name: '8' },
            { id: 9, name: '9' },
            { id: 10, name: '10' },
          ],
          model: null,
        },
        radioHealthSpecialistNecessary: {
          required: true,
          label:
            '¿Fue necesaria la participación de un especialista de la salud?:',
          errorMsg: 'Marque si o no.',
          model: null,
          options: [
            { label: 'Si', value: true },
            { label: 'No', value: false },
          ],
        },
        radioParticipatedSpecialist: {
          visible: false,
          required: false,
          label: '¿Participó el especialista?',
          errorMsg: 'Marque si o no.',
          model: null,
          options: [
            { label: 'Si', value: true },
            { label: 'No', value: false },
          ],
        },
        radioDissabilities: {
          options: [
            {
              label:
                'El estudiante no presenta una discapacidad según se define en la Ley IDEA.',
              value: 1,
            },
            {
              label:
                'El estudiante presenta una discapacidad, pero esta no limita negativamente su educación.',
              value: 2,
            },
            {
              label:
                'El estudiante presenta una discapacidad que lo limita negativamente su educación.',
              value: 3,
            },
          ],
        },
        dropDownImpediment: {
          required: true,
          disabled: false,
          visible: false,
          label: 'Impedimento:',
          name: 'dropDownImpediment',
          placeHolder: 'Seleccione',
          fieldkey: 'id',
          fieldname: 'name',
          fieldTitle: 'title',
          fieldSubTitle: 'subTitle',
          errorMsg: 'El impedimento es requerido.',
          items: [],
          model: null,
        },
        dropDownSeverity: {
          required: false,
          disabled: false,
          visible: false,
          label: 'Severidad:',
          name: 'dropDownSeverity',
          placeHolder: 'Seleccione',
          fieldkey: 'id',
          fieldname: 'name',
          errorMsg: 'La severidad es requerida.',
          items: [],
          model: null,
        },
        dropDownDisorders: {
          required: false,
          disabled: false,
          visible: false,
          label: 'Trastorno:',
          name: 'dropDownDisorders',
          placeHolder: 'Seleccione',
          fieldkey: 'id',
          fieldname: 'name',
          errorMsg: 'El trastorno es requerido.',
          items: [],
          model: null,
        },
        checkboxCertification: {
          name: 'checkboxCertification',
          required: this.model != null && this.model.eligibilityFlag == '1',
          visible: false,
          errorMsg: 'Favor certificar la elegibilidad.',
          model: null,
        },
        checkboxPartialDeaf: {
          name: 'checkboxPartialDeaf',
          visible: false,
          label: 'Sordo Parcial',
          model: null,
        },
        dropDownImpedimentMultiple: {
          required: false,
          label: 'Impedimentos:',
          name: 'dropDownImpedimentMultiple',
          placeHolder: 'Seleccione',
          fieldkey: 'id',
          fieldname: 'name',
          errorMsg: 'Favor añadir los impedimentos múltiples.',
          items: [],
          selectedItems: [],
          model: null,
        },
        dropDownSeverityMultiple: {
          required: false,
          disabled: false,
          visible: false,
          label: 'Severidad:',
          name: 'dropDownSeverityMultiple',
          placeHolder: 'Seleccione',
          fieldkey: 'id',
          fieldname: 'name',
          errorMsg: 'La severidad es requerida.',
          items: [],
          model: null,
        },
        dropDownDisordersMultiple: {
          required: false,
          disabled: false,
          visible: false,
          label: 'Trastorno:',
          name: 'dropDownDisordersMultiple',
          placeHolder: 'Seleccione',
          fieldkey: 'id',
          fieldname: 'name',
          errorMsg: 'El trastorno es requerido.',
          items: [],
          model: null,
        },
        checkboxPartialDeafMultiple: {
          name: 'checkboxPartialDeafMultiple',
          visible: false,
          label: 'Sordo Parcial',
          model: null,
        },
      },
      model: null,
      tardinessModel: {
        tardinessReason: null,
        tardinessComment: null,
      },
      conditionsList: [],
      modelConditions: {
        isConditionsInProcessNecessary: null,
        eligibilityDeterminationConditions: {
          condition: null,
          selectedItems: [],
        },
      },
      determinationQuestionsStartDate: null,
    };
  },
  props: {
    dateEligibility: {
      type: [Date, String],
      default: () => null,
    },
    dateRegistration: {
      type: Date,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    get: {
      type: Object,
      default: () => null,
    },
    getInfo: {
      type: Boolean,
      default: () => false,
    },
    getAllData: {
      type: Boolean,
      default: () => false,
    },
    calledFrom: {
      type: String,
      default: () => new String(),
    },
    hasValidationPending: {
      type: Boolean,
      default: () => false,
    },
    fieldModel: {
      type: Object,
      default: () => null,
    },
    showInterventionQuestionnaire: {
      type: Boolean,
      default: () => true,
    },
    registry: {
      type: Object,
      default: () => null,
    },
    studentRegistryStatus: {
      type: Number,
      default: () => null,
    },
    isInitialRegistry: {
      type: Boolean,
      default: () => false,
    },
    tardinessInfo: {
      type: Object,
      default: () => ({
        isDeterminationLate: false,
        tardinessReasons: [],
        tardinessComment: null,
        tardinessReasonId: null,
      }),
    },
    placementCommitteId: {
      type: [String, Number],
      default: () => null,
    },
  },
  methods: {
    emitModel() {
      //JA: Retrieving a usable model (this component must be refactored)
      this.model = this.getActualModelData();

      this.$emit('on-eligibility-data-changed', {
        ...this.model,
        ...{
          tardinessComment: this.tardinessModel.tardinessComment,
          tardinessReasonId: this.tardinessReasonId,
          impedimentsOptions: this.impedimentsOptions,
          conditionsInProcessNecessaryFlag:
            this.modelConditions.isConditionsInProcessNecessary == null
              ? false
              : this.modelConditions.isConditionsInProcessNecessary,
          eligibilityDeterminationConditions: this.modelConditions.eligibilityDeterminationConditions.selectedItems.map(
            (c) => c.id
          ),
          dissabilityOption: this.field.dissabilityOption
            ? Number(this.field.dissabilityOption)
            : null,
        },
      });
    },
    radioElegibilityChange(isElegibility) {
      if (isElegibility != null)
        this.field.radioElegibility.model = isElegibility;
      else isElegibility = false;

      this.field.dropDownImpediment.visible = isElegibility;
      this.field.dropDownImpediment.required = isElegibility;
      this.field.dropDownImpediment.model = null;

      this.field.checkboxCertification.visible = isElegibility;
      this.field.checkboxCertification.required = isElegibility;
      this.field.checkboxCertification.model = null;
      this.field.dissabilityOption = null;

      this.canShowQuestinnarieLink(this.field.radioElegibility.model);
    },
    radioHealthSpecialistNecessaryChange(isHealthSpecialistNecessary) {
      if (isHealthSpecialistNecessary == null) {
        this.field.radioHealthSpecialistNecessary.model = null;
        this.field.radioParticipatedSpecialist.visible = false;
        this.field.radioParticipatedSpecialist.required = false;
        this.field.radioParticipatedSpecialist.model = null;
      } else {
        this.field.radioHealthSpecialistNecessary.model = isHealthSpecialistNecessary;
        this.field.radioParticipatedSpecialist.visible = isHealthSpecialistNecessary;
        this.field.radioParticipatedSpecialist.required = isHealthSpecialistNecessary;
        this.field.radioParticipatedSpecialist.model = null;
      }
    },
    radioParticipatedSpecialistChange(isParticipatedSpecialist) {
      this.field.radioParticipatedSpecialist.model = isParticipatedSpecialist;
    },
    setImpedimentMultiple(impedimentMultipleSelected) {
      let item = {};
      item.id = impedimentMultipleSelected.id;
      item.association = null;
      item.title = impedimentMultipleSelected.name;

      return item;
    },
    btnAddClick(impediment) {
      let item = this.setImpedimentMultiple(impediment);

      if (item) {
        this.removeAddImpedimentMultipleItem(item);
      }
    },
    removeAddImpedimentMultipleItem(item) {
      this.field.dropDownImpedimentMultiple.selectedItems.push(item);

      this.field.dropDownImpedimentMultiple.model = null;
      this.field.dropDownImpedimentMultiple.items = this.field.dropDownImpedimentMultiple.items.filter(
        (x) => x.id !== item.id
      );
    },
    removeAddImpedimentMultipleItemSelected(item) {
      if (item.title) {
        item.name = item.title;
      }

      this.field.dropDownImpedimentMultiple.items.push(item);

      this.field.dropDownImpedimentMultiple.model = null;
      this.field.dropDownImpedimentMultiple.selectedItems = this.field.dropDownImpedimentMultiple.selectedItems.filter(
        (x) => x.id !== item.id
      );
    },
    async getImpediments() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet(
            'api/triannualstudentevaluation/gettrianualfilteredimpediments'
          )
          .then((res) => {
            this.field.dropDownImpediment.items = res.data ? res.data : [];
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    async getImpedimentsMultiple() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet(
            'api/triannualstudentevaluation/gettrianualfilteredmultipleimpediments'
          )
          .then((res) => {
            self.field.dropDownImpedimentMultiple.items = res.data
              ? res.data
              : [];
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    async getSeverity() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet('api/code/GetEduEspCodes?codeType=7')
          .then((res) => {
            const data = res.data ? res.data : [];
            self.field.dropDownSeverity.items = data;
            self.field.dropDownSeverityMultiple.items = data;
            resolve(res.data);
          })
          .catch((err) => {
            this.response = err;
          });
      });
      return promise;
    },
    async getDisorders() {
      let self = this;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet('api/code/GetEduEspCodes?codeType=8')
          .then((res) => {
            const data = res.data ? res.data : [];
            self.field.dropDownDisorders.items = data;
            self.field.dropDownDisordersMultiple.items = data;
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    async getConditionsCatalog() {
      await studentTrianualService
        .getEligibilityDeterminationConditions()
        .then((res) => {
          this.conditionsList = res.data;
        });
    },
    async getSystemParameters() {
      const { data } = await getSysparameterByNames({
        parameterNames: ['ElgibilityDeterminationNewQuestionsStartDate'],
      });

      if (data && data.length > 0) {
        this.determinationQuestionsStartDate = new Date(data[0].staticValue);
      }
    },
    setEvaluationDateInfo() {
      if (this.get === null) return;

      if (this.get.eligibilityDeterminationDate) {
        this.field.datePickerDate.model = new Date(
          this.get.eligibilityDeterminationDate
        );
      }

      this.field.textAreaComment.model = this.get.eligibilityComment;

      if (this.get.postEligibilityMeetingsQty) {
        this.field.dropDownNumberMeetingsSelectEligibility.model = {
          id: this.get.postEligibilityMeetingsQty,
          name: this.get.postEligibilityMeetingsQty,
        };
      }

      this.radioElegibilityChange(
        this.get.eligibilityFlag != null
          ? this.get.eligibilityFlag === '1'
          : null
      );
      this.radioHealthSpecialistNecessaryChange(
        this.get.healthSpecialistParticipationFlag != null
          ? this.get.healthSpecialistParticipationFlag === '1'
          : null
      );
      this.radioParticipatedSpecialistChange(
        this.get.healthSpecialistParticipatedFlag === '1'
      );

      let impedimentSelected = this.field.dropDownImpediment.items.filter(
        (x) => x.id === this.get.impedimentId
      );
      this.field.dropDownImpediment.model = impedimentSelected[0];

      let itemSeverity = this.field.dropDownSeverity.items.filter(
        (x) => x.id === this.get.impedimentSeverityCode
      );
      this.field.dropDownSeverity.model =
        itemSeverity.length > 0 ? itemSeverity[0] : null;

      let itemDisorders = this.field.dropDownDisorders.items.filter(
        (x) => x.id === this.get.impedimentAutismCode
      );
      this.field.dropDownDisorders.model =
        itemDisorders.length > 0 ? itemDisorders[0] : null;

      let items = [];

      if (this.get.multipleImpedimentInfo != undefined) {
        let itemPartialHearingMultiple = this.get.multipleImpedimentInfo.filter(
          (x) => x.impedimentDesc === ImpedimentsEnum.HI_ProblemaAudicion
        );
        this.field.checkboxPartialDeafMultiple.model =
          itemPartialHearingMultiple.length > 0
            ? itemPartialHearingMultiple[0].partialHearingFlag
            : null;

        let itemTrastornoAutista = this.get.multipleImpedimentInfo.filter(
          (x) => x.impedimentDesc === ImpedimentsEnum.AUT_Autismo
        );
        if (itemTrastornoAutista.length > 0) {
          let itemDisordersTrastornoAutista = this.field.dropDownDisordersMultiple.items.filter(
            (x) => x.id === itemTrastornoAutista[0].autismId
          );
          this.field.dropDownDisordersMultiple.model =
            itemDisordersTrastornoAutista[0];
        }

        this.get.multipleImpedimentInfo.forEach((item) => {
          let itemMultiple = this.field.dropDownImpedimentMultiple.items.filter(
            (x) => x.id === item.impedimentId
          );
          this.field.dropDownImpedimentMultiple.model =
            itemMultiple.length > 0 ? itemMultiple[0] : null;

          let severityItems = this.field.dropDownSeverityMultiple.items.filter(
            (x) => x.id === item.severityId
          );
          this.field.dropDownSeverityMultiple.model =
            severityItems.length > 0 ? severityItems[0] : null;

          this.setImpedimentMultiple(
            this.field.dropDownImpedimentMultiple.model
          );

          if (itemMultiple.length > 0) items.push(itemMultiple[0]);
        });
      }

      this.field.dropDownImpedimentMultiple.selectedItems = items;
      this.field.checkboxCertification.model =
        this.get.eligibilityFlag === '1' && this.get.impedimentId != null;
      this.field.checkboxPartialDeaf.model =
        this.get.impedimentPartialHearingFlag === '1';
    },
    filterImpediments(data) {
      return data.filter((item) => {
        return item.id == this.get.impedimentId;
      });
    },
    getData() {
      let multipleImpediments = [];
      this.field.dropDownImpedimentMultiple.selectedItems.forEach((item) => {
        let impedimentItem = {
          impedimentId: item.id,
          severityId:
            item.title === ImpedimentsEnum.MR_DiscapacidadIntelectual
              ? item.association
              : null,
          autismId:
            item.title === ImpedimentsEnum.AUT_Autismo
              ? item.association
              : null,
          partialHearingFlag:
            item.title === ImpedimentsEnum.HI_ProblemaAudicion
              ? item.association
              : null,
          name:
            item.title === ImpedimentsEnum.MR_DiscapacidadIntelectual ||
            item.title === ImpedimentsEnum.AUT_Autismo ||
            item.title === ImpedimentsEnum.HI_ProblemaAudicion
              ? item.title
              : item.name,
        };
        multipleImpediments.push(impedimentItem);
      });

      return {
        comment: this.field.textAreaComment.model,
        isElegibility: this.field.radioElegibility.model,
        numberMeetingsSelectEligibility: this.field
          .dropDownNumberMeetingsSelectEligibility.model
          ? this.field.dropDownNumberMeetingsSelectEligibility.model.id
          : null,
        isCertification: this.field.checkboxCertification.model,
        isHealthSpecialistNecessary: this.field.radioHealthSpecialistNecessary
          .model,
        isParticipatedSpecialist: this.field.radioParticipatedSpecialist.model,
        eligibilityDeterminationDate: this.field.datePickerDate.model,

        impedimentSelected:
          this.field.dropDownImpediment.model != null
            ? this.field.dropDownImpediment.model.id
            : null,
        impedimentNameSelected:
          this.field.dropDownImpediment.model != null
            ? this.field.dropDownImpediment.model.name
            : null,
        severitySelected:
          this.field.dropDownSeverity.model != null
            ? this.field.dropDownSeverity.model.id
            : null,
        disorderSelected:
          this.field.dropDownDisorders.model != null
            ? this.field.dropDownDisorders.model.id
            : null,
        isPartialDeaf:
          this.field.checkboxPartialDeaf.model != null
            ? this.field.checkboxPartialDeaf.model
            : null,

        impedimentMultipleSelected: multipleImpediments,
        questionnaireStatus: this.field.questionnaireStatus,
      };
    },
    getActualModelData() {
      let multipleImpediments = [];
      this.field.dropDownImpedimentMultiple.selectedItems.forEach((item) => {
        let impedimentItem = {
          impedimentId: item.id,
          severityId:
            item.title === ImpedimentsEnum.MR_DiscapacidadIntelectual
              ? item.association
              : null,
          autismId:
            item.title === ImpedimentsEnum.AUT_Autismo
              ? item.association
              : null,
          partialHearingFlag: (item.title ===
          ImpedimentsEnum.HI_ProblemaAudicion
          ? item.association
          : null)
            ? '1'
            : '0',
          name:
            item.title === ImpedimentsEnum.MR_DiscapacidadIntelectual ||
            item.title === ImpedimentsEnum.AUT_Autismo ||
            item.title === ImpedimentsEnum.HI_ProblemaAudicion
              ? item.title
              : item.name,
        };
        multipleImpediments.push(impedimentItem);
      });

      let result = {
        eligibilityDeterminationDate: this.field.datePickerDate.model,
        eligibilityFlag:
          this.field.radioElegibility.model != null
            ? this.field.radioElegibility.model
              ? '1'
              : '0'
            : null,
        impedimentId:
          this.field.dropDownImpediment.model != null
            ? this.field.dropDownImpediment.model.id
            : null,
        impedimentDesc:
          this.field.dropDownImpediment.model != null
            ? this.field.dropDownImpediment.model.name
            : null,
        impedimentSeverityCode:
          this.field.dropDownSeverity.model != null
            ? this.field.dropDownSeverity.model.id
            : null,
        impedimentSeverityDesc:
          this.field.dropDownSeverity.model != null
            ? this.field.dropDownSeverity.model.name
            : null,
        impedimentAutismCode:
          this.field.dropDownDisorders.model != null
            ? this.field.dropDownDisorders.model.id
            : null,
        impedimentAutismDesc:
          this.field.dropDownDisorders.model != null
            ? this.field.dropDownDisorders.model.name
            : null,
        impedimentPartialHearingFlag:
          this.field.checkboxPartialDeaf.model != null
            ? this.field.checkboxPartialDeaf.model
              ? '1'
              : '0'
            : null,
        impedimentPartialHearingDesc: null,
        eligibilityComment: this.field.textAreaComment.model,
        healthSpecialistParticipationFlag:
          this.field.radioParticipatedSpecialist.model != null
            ? this.field.radioParticipatedSpecialist.model
              ? '1'
              : '0'
            : null,
        healthSpecialistParticipatedFlag:
          this.field.radioHealthSpecialistNecessary.model != null
            ? this.field.radioHealthSpecialistNecessary.model
              ? '1'
              : '0'
            : null,
        postEligibilityMeetingsQty: this.field
          .dropDownNumberMeetingsSelectEligibility.model
          ? this.field.dropDownNumberMeetingsSelectEligibility.model.id
          : null,
        MultipleImpedimentInfo: multipleImpediments,
      };

      return result;
    },
    registerLocalObservers() {
      this.observersForValidate = [
        { name: 'elegibilityDetermination', observer: this.$refs.observer },
      ];
    },
    canShowQuestinnarieLink(canRequest) {
      if (!canRequest || this.calledFrom !== 'post-registry') {
        this.field.showQuestionnaireForStudent = false;
        return;
      }

      let uri =
        this.calledFrom == 'post-registry' && this.registry != null
          ? `/api/pei/${
              this.isInitialRegistry
                ? this.registry.regStudentId
                : this.registry.regStudentPostRegistryId
            }/${this.isInitialRegistry}/canShowQuestionnaireForStudent`
          : `/api/pei/canShowQuestionnaireForStudent/${this.$store.getters.SelectedStudent.studentId}`;

      this.$ApiGet(uri, false)
        .then((res) => {
          if (res.data) {
            this.field.showQuestionnaireForStudent =
              res.data.canShowQuestionnaireAlert;
            this.field.questionnaireStatus = res.data.status;
          }
        })
        .catch((err) => {
          this.ShowToast('Error', err.response.data.message, 'error');
        });
    },
    validateImpediments() {
      if (this.$refs.ImpedimentsManager) {
        return this.$refs.ImpedimentsManager.validate();
      } else {
        return true;
      }
    },
    async fetchImpedimentOptions() {
      try {
        let uri = `/api/triannualstudentevaluation/optionsbyimpediment`;
        uri = this.placementCommitteId
          ? `${uri}/${this.placementCommitteId}`
          : uri;
        const { data } = await this.$ApiGet(uri);

        this.impedimentsOptions = data;
      } catch (err) {
        this.ShowToast(
          'Error',
          'Ocurrio un problema recuperando informacion de los impedimentos',
          'error'
        );
      }
    },
  },
  async mounted() {
    this.$emit('getRef', 'elegibility', this.$refs.observer);
    this.registerLocalObservers();
    await Promise.all([
      this.getSeverity(),
      this.getDisorders(),
      this.getImpediments(),
      this.getImpedimentsMultiple(),
      this.getConditionsCatalog(),
      this.getSystemParameters(),
    ]);
    this.setEvaluationDateInfo();

    if (this.fieldModel != null) {
      this.field = this.fieldModel;
    }
    this.canShowQuestinnarieLink(this.field.radioElegibility.model);
    this.fetchImpedimentOptions();
  },
  watch: {
    get: {
      deep: true,
      immediate: true,
      async handler(newValue) {
        if (!newValue) return;

        this.impedimentsModel.isPartialHearing =
          newValue.impedimentPartialHearingFlag;
        this.field.dissabilityOption = newValue.dissabilityOption;

        await Promise.all([
          this.getSeverity(),
          this.getDisorders(),
          this.getImpediments(),
          this.getImpedimentsMultiple(),
          this.getConditionsCatalog(),
        ]).then(() => {
          let itemSeverity = this.field.dropDownSeverity.items.filter(
            (x) => x.id == newValue.impedimentSeverityCode
          );
          this.impedimentsModel.severity = newValue.impedimentSeverityCode
            ? itemSeverity[0]
            : null;

          let itemDisorders = this.field.dropDownDisorders.items.filter(
            (x) => x.id == newValue.impedimentAutismCode
          );

          this.impedimentsModel.disorders = newValue.impedimentAutismCode
            ? itemDisorders[0]
            : null;

          this.modelConditions.isConditionsInProcessNecessary = false;
          if (
            newValue.eligibilityDeterminationConditions &&
            newValue.eligibilityDeterminationConditions.length > 0
          ) {
            newValue.eligibilityDeterminationConditions.forEach((x) => {
              let condition = this.conditionsList.find((c) => c.id == x);

              //Set Item
              let item = {};
              item.id = condition.id;
              item.association = null;
              item.title = condition.name;
              item.code = condition.code;
              this.modelConditions.eligibilityDeterminationConditions.selectedItems.push(
                item
              );
            });
            this.modelConditions.isConditionsInProcessNecessary = true;
          }
        });
      },
    },
    impedimentsModel: {
      deep: true,
      handler(newValue) {
        this.field.dropDownSeverity.model = newValue.severity;
        this.field.dropDownSeverityMultiple.model = newValue.severity;

        this.field.dropDownDisorders.model = newValue.disorders;
        this.field.dropDownDisordersMultiple.model = newValue.disorders;

        this.field.checkboxPartialDeaf.model = newValue.isPartialHearing;
        this.field.checkboxPartialDeafMultiple.model =
          newValue.isPartialHearing;
      },
    },
    getAllData() {
      if (this.getAllData === true) this.$emit('data', this.getData());
    },
    dateEligibility() {
      this.field.datePickerDate.model = this.dateEligibility;
    },
    getInfo: async function(newValue) {
      if (newValue) {
        this.$emit('data', this.getData());
      }
    },
    'tardinessInfo.tardinessReasons': {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length === 1) {
          this.tardinessModel.tardinessReason = newValue[0];
        }
      },
    },
    'tardinessInfo.tardinessComment': {
      immediate: true,
      handler(newValue) {
        if (newValue && newValue.length > 0) {
          this.tardinessModel.tardinessComment = newValue;
        }
      },
    },
    modelConditions: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.emitModel();
        }
      },
    },
    tardinessModel: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.emitModel();
        }
      },
    },
    field: {
      deep: true,
      handler(newValue) {
        this.$emit('getFieldModel', newValue);
        this.emitModel();
      },
    },
    disabled(newValue) {
      this.field.datePickerDate.disabled =
        newValue || (this.dateRegistration ? false : true);
    },
  },
  computed: {
    selectedImpedimentIds() {
      if (!this.field.dropDownImpediment.model) return [];

      if (
        this.field.dropDownImpediment.model.name !=
        ImpedimentsEnum.MD_ImpedimentosMultiples
      )
        return [this.field.dropDownImpediment.model.id];

      return [
        this.field.dropDownImpediment.model.id,
        ...this.field.dropDownImpedimentMultiple.selectedItems.map((x) => x.id),
      ];
    },
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    tardinessReasonId() {
      return this.tardinessModel && this.tardinessModel.tardinessReason
        ? this.tardinessModel.tardinessReason.id
        : null;
    },
    showTardinessComment() {
      return this.tardinessReasonId === tardyRegistrationReasons.Otros;
    },
    canShowInterventionQuestionnaire() {
      const studentStatusId =
        this.studentRegistryStatus ??
        this.$store.getters.SelectedStudent.statusId;
      return (
        this.showInterventionQuestionnaire &&
        (studentStatusId == StudentStatuses.Evaluado ||
          (studentStatusId !== StudentStatuses.Evaluado &&
            this.field.questionnaireStatus == QuestionnarieStatus.Completado))
      );
    },
    hasMultiple() {
      return (
        this.field.dropDownImpediment.model &&
        this.field.dropDownImpediment.model.name ==
          ImpedimentsEnum.MD_ImpedimentosMultiples
      );
    },
    canShowDeterminationQuestions() {
      if (!this.determinationQuestionsStartDate || !this.dateEligibility) {
        return true;
      }

      const _elegibilityDate = new Date(this.dateEligibility);
      return _elegibilityDate >= this.determinationQuestionsStartDate;
    },
    elegibilityTardinessReasons() {
      const notElegibleReasons = [
        tardyRegistrationReasons.AusenciaRecurrentePorPartePadresEvaluacionInicial,
      ];
      return this.tardinessInfo.tardinessReasons.filter(
        (t) => !notElegibleReasons.includes(t.id)
      );
    },
  },
};
</script>

<style src="@/assets/css/component/badge.css"></style>
<style scoped src="@/assets/css/component/radio-button.css" />

<style scoped lang="scss">
.separator {
  margin-top: 60px;
}
.student-search-alert-error.no-border {
  padding-left: 0;
}
.student-search-alert-error {
  background: none;
  border: none;
  padding: 0;
}
.dropdown-divider {
  margin-top: 20px;
  border-top: 2px solid #e9ecef;
}
.error-block {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #ff5b5c;
  border-radius: 4px;
  opacity: 1;
  padding: 10px;
  margin-bottom: 30px;
}
.error-block i {
  color: #ff5b5c;
  margin-right: 10px;
}
.error-block span {
  text-align: left;
  font: Regular 16px/24px Lato;
  letter-spacing: 0;
  color: #ff5b5c;
  opacity: 1;
}
.date-spacing {
  margin-right: 120px;
}
.error-margin-left {
  margin-left: -20px !important;
}
.bg-impediment {
  background: #ffffff 0% 0% no-repeat padding-box;
  padding: 20px;
  margin: 20px;
}
.comment-spacing {
  margin-top: 65px;
}
.custom-chips >>> .chips-container {
  -webkit-box-shadow: none !important;
  margin-top: -30px;
}
.custom-chips >>> .chips {
  margin-left: -2px;
  margin-right: 50px;
}
.b {
  font-weight: bolder !important;
}
.tag-badge {
  display: inline-block;
  padding-right: 1em;
  height: 42px;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
  margin-bottom: 10px;
}
.dot {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  display: inline-block;
  /* top: 268px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
}
.orange-icon {
  color: #ff7058;
}
.orange-icon-badge-align {
  vertical-align: top;
}
.tag-badge-title {
  text-align: left;
  font: Bold 25px/30px Lato;
  letter-spacing: 0;
  color: #11291b;
  display: inline-block;
}
.item-pane {
  justify-content: space-between;
  min-width: 50%;
  box-shadow: -3px 1px 3px #00000029;
  margin-top: 10px;
  display: flex;
  border-bottom: solid 1px #e2e2e2;
}
.item-pane-info {
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-radius: 0px 0px 5px 5px;
  margin-bottom: 10px;
  font: 400 14px/17px Lato;
  letter-spacing: 0;
  color: #11291b;
  padding: 20px 10px 10px;
}
.item-pane-info p {
  margin-bottom: 10px;
}
.item-pane-info p i {
  margin-right: 8px;
  font-size: 16px;
}
.question-box {
  width: 65px;

  border-radius: 5px 5px 0px 0px;
  text-align: center;
  color: #ffffff;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  /* padding: 22px 12px; */
}
.border-box {
  border: 1px solid #e2e2e2;
  border-radius: 5px 5px 0px 0px;
  padding: 20px;
  width: 100%;
}
.border-box.gray {
  border-radius: 0px 0px 5px 0px;
  background: #f2f2f2 0% 0% no-repeat padding-box;
  border-top: none;
  padding: 20px 0;
}
.border-box.gray.error {
  background: #ffebeb 0% 0% no-repeat padding-box;
  border: 1px solid #c9545e;
}
.invalid {
  text-align: left;
  font: Lato, Regular;
  letter-spacing: 0;
  color: #ff5b5c;
  margin-bottom: 5px;
  font-weight: normal;
}
i.far.fa-check-circle {
  font-size: 24px;
  padding-right: 4px;
  line-height: 18px;
  margin-left: 4px;
}
.certificate-spacing {
  margin-right: -110px;
}
.terms-block {
  margin-left: -38px;
}
.align-group {
  margin-left: -16px;
}
.container-impediment-selected {
  margin-top: -25px;
}
.bottom-space {
  margin-bottom: -45px;
}
.align-eligibility {
  margin-left: -17px;
  margin-top: 10px;
}
.healt-specialist {
  margin-left: -15px;
  margin-top: 10px;
}
@media only screen and (min-width: 600px) {
  .align-eligibility {
    margin-left: 10px;
    margin-top: 0px;
  }
  .healt-specialist {
    margin-left: 1px;
    margin-top: 24px;
  }
}

.mw-150 {
  min-width: 150px;
}

.dissability-options {
  ::v-deep {
    .col-12 {
      padding: 0;
    }
    .custom-radio {
      margin-bottom: 0.7rem;
    }
    .custom-control-label {
      font-weight: 700;
    }
  }
}
</style>
